/* =============================================================
 * import
 * ========================================================== */
import {gsap} from "gsap";
import {CustomEase} from "gsap/CustomEase";
import subKvAnimation from "../../modules/subKvAnimation";

CustomEase.create("fadeCurtain", ".25, .46, .45, .94");
CustomEase.create("fade", "0.5, 1, 0.89, 1");
const tl = gsap.timeline();


/* =============================================================
 * functions
 * ========================================================== */
export function leave(data, duration = 1000) {
  const ms = duration / 1000;
  const filters = document.querySelectorAll('.filter_bg_item');

  gsap.to(data.current.container, {
    autoAlpha: 0,
    ease: "fade",
    duration: ms,
  });
  filters.forEach(filter => {
    gsap.set(filter, {
      autoAlpha: 0,
      scale: 1,
    });
  });

}


export function enter(data) {

  gsap.set(data.next.container, {
    autoAlpha: 0,
  });

}


export function after(data, duration = 1000) {
  const ms = duration / 1000;

  tl
    .fromTo(
      data.next.container,
      {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
        ease: "fade",
        duration: ms,
      },
    )
  ;

  subKvAnimation(data.next.container, true);
}

